'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, type ReactNode, useContext } from 'react';
import type { ModalAdapter } from './types';
const ModalAdapterContext = createContext<ModalAdapter | null>(null);
export interface ModalAdapterProviderProps {
  adapter: ModalAdapter;
  children: ReactNode;
}
export function ModalAdapterProvider(t0) {
  const $ = _c(3);
  const {
    adapter,
    children
  } = t0;
  let t1;
  if ($[0] !== adapter || $[1] !== children) {
    t1 = <ModalAdapterContext.Provider value={adapter}>{children}</ModalAdapterContext.Provider>;
    $[0] = adapter;
    $[1] = children;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function useModalAdapter() {
  const adapter = useContext(ModalAdapterContext);
  if (!adapter) {
    throw new Error("useModalAdapter must be used within a ModalAdapterProvider");
  }
  return adapter;
}

/**
 * Optional version - returns null if no provider
 * Useful for gradual migration
 */
export function useModalAdapterOptional() {
  return useContext(ModalAdapterContext);
}